"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Footer = exports.AdvancedForm = exports.NormalForm = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _truncate = _interopRequireDefault(require("lodash/truncate"));

var _trim = _interopRequireDefault(require("lodash/trim"));

var _uniq = _interopRequireDefault(require("lodash/uniq"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _classnames = _interopRequireDefault(require("classnames"));

var _formik = require("formik");

var _Settings = _interopRequireDefault(require("@material-ui/icons/Settings"));

var _AddCircle = _interopRequireDefault(require("@material-ui/icons/AddCircle"));

var _Help = _interopRequireDefault(require("@material-ui/icons/Help"));

var _Button = _interopRequireDefault(require("../Button"));

var _Container = _interopRequireDefault(require("../Filter/Container"));

var _Tooltip = _interopRequireWildcard(require("../Tooltip"));

var _SearchOperators = _interopRequireDefault(require("../SearchOperators"));

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    icon: {
      fontSize: '4rem'
    }
  };
});
var opOr = ' OR ';
var opOrRegex = new RegExp('( +|^)OR( +|$)', 'gi');
var fieldPrefix = 'query';

var Main = function Main(_ref) {
  var form = _ref.form,
      footer = _ref.footer;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col justify-around h-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col justify-center flex-1"
  }, form), footer));
};

var NormalForm = function NormalForm(_ref2) {
  var values = _ref2.values,
      _name = _ref2.name,
      criterias = _ref2.criterias,
      activeCriteria = _ref2.activeCriteria,
      onAddValue = _ref2.onAddValue,
      onChangeName = _ref2.onChangeName,
      onChangeCriteria = _ref2.onChangeCriteria,
      showTip = _ref2.showTip,
      onTipClosed = _ref2.onTipClosed;
  var classes = useStyles();
  var name = (0, _react.useMemo)(function () {
    return (0, _truncate["default"])(_name, {
      length: 15
    });
  }, [_name]);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  (0, _react.useEffect)(function () {
    return function () {
      if (showTip && (0, _isFunction["default"])(onTipClosed)) {
        onTipClosed();
      }
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-3xl font-semibold sm:w-50vw sm:text-6xl text-dark"
  }, /*#__PURE__*/_react["default"].createElement(_Tooltip.ProTip, {
    open: showTip,
    title: /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-white",
      onClick: function onClick() {
        if ((0, _isFunction["default"])(onTipClosed)) {
          onTipClosed();
        }
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'text-sm'
    }, t('tooltip.protip.title')), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'text-sm pt-2 font-light'
    }, t('settings.splitInbox.name.tip.description'))),
    placement: 'top'
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-semibold cursor-pointer text-primary",
    onClick: onChangeName
  }, name)), "\xA0should include all messages", /*#__PURE__*/_react["default"].createElement("span", null, ['to', 'from'].includes(activeCriteria) ? ' ' : ' that '), /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-semibold cursor-pointer text-primary",
    onClick: onChangeCriteria
  }, (0, _get["default"])(criterias, "".concat(activeCriteria, ".label"), 'To'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-wrap mt-6 overflow-auto",
    style: {
      maxHeight: '40vh'
    }
  }, values, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "text-lg font-semibold text-gray-light",
    onClick: onAddValue
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr-2 text-primary"
  }, /*#__PURE__*/_react["default"].createElement(_AddCircle["default"], {
    classes: {
      root: classes.icon
    }
  })))));
};

exports.NormalForm = NormalForm;

var AdvancedForm = function AdvancedForm(_ref3) {
  var fields = _ref3.fields;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isShowModal = _useState2[0],
      setModal = _useState2[1];

  function handleOnChange(value, fieldProps) {
    var field = fieldProps.field,
        form = fieldProps.form;
    form.setFieldValue(field.name, value.split(opOrRegex).map(_trim["default"]).filter(Boolean));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "advanced-filter"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-6xl font-semibold text-dark"
  }, t('settings.splitInbox.advance.title')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-gray-light"
  }, t('settings.splitInbox.advance.descriptionLine1'), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: "Help"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mx-2 cursor-pointer",
    onClick: function onClick() {
      return setModal(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Help["default"], {
    fontSize: "small"
  }))), /*#__PURE__*/_react["default"].createElement("br", null), t('settings.splitInbox.advance.descriptionLine2')), /*#__PURE__*/_react["default"].createElement("table", {
    className: "sm:w-50vw mt-10 pb-6 !border-collapse"
  }, /*#__PURE__*/_react["default"].createElement("tbody", null, fields.map(function (criteria, index) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: "splitInbox".concat(criteria.name)
    }, /*#__PURE__*/_react["default"].createElement("td", {
      nowrap: true,
      className: "key align-top pt-3"
    }, criteria.label), /*#__PURE__*/_react["default"].createElement("td", {
      className: "value"
    }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
      name: "".concat(fieldPrefix, ".").concat(criteria.name),
      render: function render(fieldProps) {
        var errorMessage = (0, _uniq["default"])((0, _get["default"])(fieldProps.form.errors, fieldProps.field.name, '').toString().split(',')).filter(Boolean).toString();
        var placeHolder = '';

        if (fieldProps.field.name === 'query.to' || fieldProps.field.name === 'query.from') {
          placeHolder = t('settings.splitInbox.advance.recipient.placeholder');
        } else if (fieldProps.field.name === 'query.query' || fieldProps.field.name === 'query.subject') {
          placeHolder = t('settings.splitInbox.advance.hasWords.placeholder');
        }

        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
          className: "w-full",
          defaultValue: (0, _get["default"])(fieldProps, 'field.value', []).join(opOr),
          onChange: function onChange(e) {
            return handleOnChange(e.target.value, fieldProps);
          },
          placeholder: placeHolder
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])('text-xs text-red font-semibold', {
            invisible: !errorMessage
          })
        }, !!errorMessage ? errorMessage : 'No errors'));
      }
    })));
  }))), /*#__PURE__*/_react["default"].createElement(_SearchOperators["default"], {
    isOpen: isShowModal,
    toggle: function toggle() {
      return setModal(!isShowModal);
    }
  }));
};

exports.AdvancedForm = AdvancedForm;

var Footer = function Footer(_ref4) {
  var _ref4$matched = _ref4.matched,
      matched = _ref4$matched === void 0 ? 0 : _ref4$matched,
      _ref4$enableToSubmit = _ref4.enableToSubmit,
      enableToSubmit = _ref4$enableToSubmit === void 0 ? true : _ref4$enableToSubmit,
      _ref4$isQueryEmpty = _ref4.isQueryEmpty,
      isQueryEmpty = _ref4$isQueryEmpty === void 0 ? true : _ref4$isQueryEmpty,
      _ref4$isNewSplit = _ref4.isNewSplit,
      isNewSplit = _ref4$isNewSplit === void 0 ? true : _ref4$isNewSplit,
      isAdvanced = _ref4.isAdvanced,
      setAdvance = _ref4.setAdvance,
      onSubmit = _ref4.onSubmit,
      onCancel = _ref4.onCancel,
      onPreview = _ref4.onPreview;

  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation3.t;

  var outlineStyle = isNewSplit && isQueryEmpty;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold"
  }, matched > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-gray-light"
  }, matched, " message", matched > 1 ? 's' : '', " found.", ' '), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "font-bold text-primary",
    onClick: onPreview
  }, "Preview this view"))), !isAdvanced && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "flex items-center font-semibold text-gray-light hover:text-primary",
    onClick: setAdvance
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr-4"
  }, /*#__PURE__*/_react["default"].createElement(_Settings["default"], null)), "Need advanced options?")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex my-10 sm:block"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "button",
    color: "secondary",
    className: "flex-1 sm:w-56 mr-4",
    onClick: onCancel
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "submit",
    outline: outlineStyle,
    disabled: !enableToSubmit,
    className: "flex-1 sm:w-56",
    onClick: onSubmit
  }, outlineStyle ? t('button.maybeLater') : t('button.submit'))));
};

exports.Footer = Footer;
var _default = Main;
exports["default"] = _default;
//# sourceMappingURL=Main.js.map